import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DialogSettingsUsersSelect } from 'app/dialogs/settings/users/select/dialog-settings-users-select';
import { copyLink } from 'app/helpers/copyLink';
import { formatPhoneNumber } from 'app/helpers/formatPhoneNumber';
import { ExposedReadUserDetailsRes } from 'app/interfaces/responses/Exposed/exposedReadUserDetailsRes';
import { LsrauthService } from 'app/services/api/lsrauth/lsrauth.service';
import { TranslationService } from 'app/services/api/translation/translation.service';
import { AlertsService } from 'app/services/system/alerts/alerts.service';
import { USER_ROLES } from 'common/constants/user-role.constants';

@Component({
    selector: 'app-settings-users-user-profile',
    templateUrl: './settings-users-user-profile.component.html',
    styleUrls: ['./settings-users-user-profile.component.scss'],
})
export class SettingsUsersUserProfileComponent implements OnInit {
    userRoles = USER_ROLES;
    userDetails: ExposedReadUserDetailsRes = null;
    form: UntypedFormGroup;

    constructor(
        private formBuilder: UntypedFormBuilder,
        private lsrauthService: LsrauthService,
        private dialog: MatDialog,
        private translationService: TranslationService,
        private alertsService: AlertsService
    ) {}

    ngOnInit(): void {
        this.initForm();
    }

    initForm() {
        this.form = this.formBuilder.group({
            nafn: new UntypedFormControl({ value: '', disabled: true }),
            simanumer: new UntypedFormControl({ value: '', disabled: true }),
        });

        this.lsrauthService.userDetails.subscribe((userDetails) => {
            // Fetch user details if the current value is empty
            if (!userDetails) {
                this.lsrauthService.fetchUserDetails(true);
                return;
            }
            this.userDetails = userDetails;
            this.form.get('simanumer').setValue(formatPhoneNumber(userDetails.user.simanumer));
            this.form.get('nafn').setValue(userDetails.user.nafn);
            this.form.disable();
        });
    }

    copyLink(value) {
        copyLink(value, this.translationService.translate('info_copy_data'), this.alertsService);
    }

    openUserSelectModal() {
        const dialogRef = this.dialog.open(DialogSettingsUsersSelect, {
            autoFocus: false,
            restoreFocus: false,
            width: '450px',
            disableClose: true,
            data: {},
        });
    }
}
